import axios from 'axios';
import Vue from 'vue';
import userconfig from '../assets/config';
import {Message} from 'element-ui';
import store from '@/store';
import { showLoading, hideLoading } from './loading'

var class2type = {}
var hasOwn = class2type.hasOwnProperty

function has (obj, path) {
  return obj != null && hasOwn.call(obj, path) && obj[path]
}



// axios.defaults.timeout = 1000000;

const service = axios.create ({
  baseURL: userconfig.baseUrl,
  timeout: 30 * 1000
});
service.defaults.headers.post['Content-Type'] =
  'application/json;charset=UTF-8';
service.interceptors.request.use (
  config => {
    let url = config.url.substr(config.url.lastIndexOf('/') + 1)
    if (url.indexOf('addOrEdit') !== -1 || url.indexOf('save') !== -1 || url.indexOf('edit') !== -1) {
      showLoading()
    }
    const user = (has(store.getters.expertLoginUser, 'token') && store.getters.expertLoginUser) ||  (has(store.getters.loginUser, 'token') && store.getters.loginUser)
    let token =  user.token || ''
    config.headers.Authorization = 'Bearer ' + token
    return config;
  },
  error => {
    console.log (error);
    Promise.reject (error);
  }
);

service.interceptors.response.use (
  response => {
    const res = response.data
    // if (res.code && res.code === 401) {
    //   window.location.href = 'http://localhost:8080/#/'
    // }
    if  (res.code !== 2000) {
      Message ({
        message: '服务器错误',
        type: 'error',
        duration: 5 * 1000,
      });
    } else {
      hideLoading()
      return res.data;
    }
    hideLoading()
  },
  error => {
    Message ({
      message: '服务器错误',
      type: 'error',
      duration: 5 * 1000,
    });
    hideLoading()
    return Promise.reject (error);
  }
);

Vue.prototype.$axios = axios;
export default service;
